import { Context } from "../../../contexts/contexts.model";

export interface BaseDialogData {
	title: string;
	text: string;
}

export interface SuccessDialogData extends BaseDialogData {
	okBtnText: string;
}

export interface ErrorDialogData extends BaseDialogData {
	okBtnText: string;
}

export interface SelectContextDialogData extends BaseDialogData {
	availableContexts: Context[];
	okBtnText: string;
	cancelBtnText: string;
}

export interface ConfirmDialogData extends BaseDialogData {
	okBtnText: string;
	cancelBtnText: string;
}

export interface SelectFileDialogData extends BaseDialogData {
	accept: string;
	okBtnText: string;
	cancelBtnText: string;
}

export interface ConfirmDialogResult {
	confirm: boolean;
}

export interface SelectContextDialogResult {
	contextOriginCode: string;
}

export interface SelectFileDialogResult {
	file: any;
}
